import { EContactDetailTypes, TSetAddressEdit } from '../index';

export const setAddressEdit = (isEdit: boolean): TSetAddressEdit => ({
    type: EContactDetailTypes.SET_EDIT,
    payload: {
        isEdit,
    },
});
